import type {
  Identifier as ServerIdentifier,
  Identifier,
} from 'src/types/serverTypes/Account';

export default class IdentifierBuilder {
  static build(serverIdentifier: ServerIdentifier): Identifier {
    return {
      ...serverIdentifier,
    };
  }
}
